import styled from 'styled-components';

const BodyStyled = styled.main`
    flex: 1;
`;

export default BodyStyled;